export default __webpack_public_path__ + "static/media/sukses_pass.cf66ce9d.png";